import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AccountService } from 'app/core';
import { TimeSeriesChart } from './time-series-charts.types';
import { Project, Property } from 'app/modules/projects/projects.types';
import { ProjectsService } from 'app/modules/projects/projects.service';
import { PropertiesService } from 'app/modules/properties/properties.service';
import { TimeSeriesChartService } from './time-series-charts.service';

@Injectable({
  providedIn: 'root',
})
export class TimeSeriesChartsResolver {
  constructor(
    private _projectsService: ProjectsService,
    private _propertiesService: PropertiesService,
    private _timeSeriesChartService: TimeSeriesChartService,
    private _accountService: AccountService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<TimeSeriesChart[]> {
    this._accountService.currentAccount.subscribe((accountData) => {
      this._timeSeriesChartService.accountId = accountData.id;
    });

    if (/\/projects\//g.test(state.url)) {
      this._projectsService.project$.subscribe((project: Project) => {
        this._timeSeriesChartService.relatedToId = project?.id;
        this._timeSeriesChartService.relatedToType = 'Project';
      });
    } else if (/\/properties\//g.test(state.url)) {
      this._propertiesService.property$.subscribe((property: Property) => {
        this._timeSeriesChartService.relatedToId = property.id.toString();
        this._timeSeriesChartService.relatedToType = 'Property';
      });
    }
    return this._timeSeriesChartService.getTimeSeriesCharts();
  }
}
